module.exports = __webpack_public_path__ + "static/img/security-icon2.de4d77ba.png";